import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from './supabaseClient';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Listen for PASSWORD_RECOVERY event from Supabase
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setReady(true);
      }
    });

    // Also check if there's already a session (user navigated back to page)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setReady(true);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleReset = async () => {
    setError('');
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    if (updateError) {
      setError(updateError.message);
    } else {
      setSuccess(true);
      await supabase.auth.signOut();
      setTimeout(() => navigate('/seller/login'), 3000);
    }
    setLoading(false);
  };

  const inp = {
    width: '100%', padding: '14px 16px', border: '1.5px solid #c4a882',
    borderRadius: '12px', fontSize: '15px', fontFamily: 'Lato, sans-serif',
    boxSizing: 'border-box', outline: 'none', marginBottom: '16px',
  };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: '#f7f3ec' }}>
      <div style={{ background: '#fff', borderRadius: '24px', padding: '48px 40px', maxWidth: '440px', width: '100%', boxShadow: '0 8px 40px rgba(44,74,46,0.12)', borderTop: '4px solid #2c4a2e' }}>

        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '22px', color: '#1e3d20', fontWeight: 700 }}>True Plant Value</div>
          <div style={{ fontSize: '10px', letterSpacing: '3px', color: '#4a7c59', textTransform: 'uppercase', marginTop: '4px' }}>Rooted in Fair Value</div>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
            <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '22px', color: '#1e3d20', marginBottom: '10px' }}>Password Updated!</h2>
            <p style={{ fontFamily: 'Lato, sans-serif', fontSize: '14px', color: '#4a5e4b' }}>Redirecting you to login...</p>
          </div>
        ) : !ready ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '14px', color: '#4a5e4b', marginBottom: '16px' }}>
              Verifying your reset link...
            </div>
            <p style={{ fontFamily: 'Lato, sans-serif', fontSize: '12px', color: '#8b9e8c' }}>
              If nothing happens, your link may have expired.{' '}
              <button onClick={() => navigate('/seller/login')} style={{ background: 'none', border: 'none', color: '#4a7c59', cursor: 'pointer', textDecoration: 'underline', fontFamily: 'Lato, sans-serif', fontSize: '12px' }}>
                Request a new one
              </button>
            </p>
          </div>
        ) : (
          <>
            <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '24px', color: '#1e3d20', marginBottom: '8px', textAlign: 'center' }}>Set New Password</h2>
            <p style={{ fontFamily: 'Lato, sans-serif', fontSize: '14px', color: '#4a5e4b', textAlign: 'center', marginBottom: '28px' }}>Choose a strong password for your seller account.</p>

            <label style={{ display: 'block', fontSize: '11px', letterSpacing: '1px', textTransform: 'uppercase', color: '#4a7c59', fontWeight: 700, marginBottom: '6px', fontFamily: 'Lato, sans-serif' }}>New Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Minimum 8 characters" style={inp} />

            <label style={{ display: 'block', fontSize: '11px', letterSpacing: '1px', textTransform: 'uppercase', color: '#4a7c59', fontWeight: 700, marginBottom: '6px', fontFamily: 'Lato, sans-serif' }}>Confirm Password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Re-enter your password" style={{ ...inp, marginBottom: '24px' }}
              onKeyDown={(e) => e.key === 'Enter' && handleReset()} />

            {error && <p style={{ color: '#c0392b', fontFamily: 'Lato, sans-serif', fontSize: '13px', marginBottom: '16px', textAlign: 'center' }}>{error}</p>}

            <button onClick={handleReset} disabled={loading}
              style={{ width: '100%', padding: '16px', background: loading ? '#8fb99a' : 'linear-gradient(135deg, #2c4a2e, #4a7c59)', color: '#f5f0e8', border: 'none', borderRadius: '14px', fontSize: '15px', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'Lato, sans-serif', letterSpacing: '1px' }}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;